import { render, staticRenderFns } from "./FormInformations.vue?vue&type=template&id=73fbbf1a&scoped=true&"
import script from "./FormInformations.vue?vue&type=script&lang=js&"
export * from "./FormInformations.vue?vue&type=script&lang=js&"
import style0 from "./FormInformations.vue?vue&type=style&index=0&id=73fbbf1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fbbf1a",
  null
  
)

export default component.exports